<template>
  <!-- https://www.jianshu.com/p/c7ecd50f2e52 -->
  <div class="home-category">
    <div class="scroll-wrapper"
         ref="scroll">

      <div class="scroll-content">
        <div style="display: flex;flex-wrap: wrap">
          <div style="padding: 5px 12px;font-size: 13px;color: #666666;"
               v-for="(item, index) in cates"
               :key="index"
               @click="onNavigate(item)">

            <div>
              <img :src="item.image" v-if="item.type == 1 || item.type == 2" class="item-img"/>
              <span class="text ">{{item.name}}</span>
            </div>
          </div>
        </div>
        <!--5个以上-->
        <!--<div v-if="cates.length > 5" class="scroll-item__wrapper"-->
             <!--v-for="(cate,idx) in list"-->
             <!--:key="idx">-->

          <!--<div class="scroll-item"-->
               <!--v-for="(item, index) in cate"-->
               <!--:key="index"-->
               <!--@click="onNavigate(item)">-->

            <!--<div v-if="idx == 0">-->
               <!--<img :src="item.image" v-if="item.type == 1 || item.type == 2"/>-->
               <!--<p class="text ">{{item.name}}</p>-->
            <!--</div>-->

            <!--<div v-if="idx == 1">-->
               <!--<img :src="item.image" v-if="item.type == 1 || item.type == 2"/>-->
               <!--<p class="text ">{{item.name}}</p>-->
            <!--</div>-->

            <!--<div style="width: 45px; height: 45px;background-color: #F3F3F3;border-radius: 50%;margin: 0 15px;" v-if="cates.length > 9 && idx == 1 && index == 4">-->
              <!--<img src="@/assets/gengduo.png" style="width: 15px;height: 15px;position: relative;top: 15px;"/>-->
            <!--</div>-->
            <!--<p class="text" v-if="cates.length > 9 && idx == 1 && index == 4">查看全部</p>-->
          <!--</div>-->
        <!--</div>-->
        <!--5个以内-->
        <!--<div v-if="cates.length <= 5" class="scroll-item__wrapper"-->
             <!--v-for="(cate,idx) in list"-->
             <!--:key="idx">-->

          <!--<div class="scroll-item"-->
               <!--v-for="(item, index) in cate"-->
               <!--:key="index"-->
               <!--@click="onNavigate(item)">-->

            <!--<div>-->
               <!--<img :src="item.image" v-if="item.type == 1 || item.type == 2"/>-->
               <!--<p class="text ellipsis">{{item.name}}</p>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->

      </div>
    </div>
    <div class="dot-wrapper" v-if="list && list.prev && list.prev.length > 5">
      <div class="dot" :style="{'transform': `translateX(${rate})`}"></div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'

export default {
  props: {
    cateList: {
      type: Array,
      default: []
    },
    tab: {
      type:  Number
    }
  },
  data () {
    return {
      rate: 0,
      breakPoint: 0,
      cates : []
    }
  },
  computed: {
    list () {
      this.cates = this.cateList
      let rlt = {}
      const data = this.cateList
      const len = this.cateList.length
      if (len <= 5) {
        rlt = {
          0: data,
          1: []
        }
      } else if (len > 5 && len <= 10) {
        rlt = {
          0: data.slice(0, 5),
          1: data.slice(5)
        }
      } else {
        const breakPoint = Math.ceil(data.length / 2)
        rlt = {
          0: data.slice(0, breakPoint),
          1: data.slice(breakPoint)
        }
      }
      console.log(rlt)
      return rlt
    }
  },
  beforeDestroy () {
    if (this.bs) this.bs.destroy()
  },
  beforeRouteLeave (to, from, next) {
    localStorage.setItem("scrollHomeCategory", document.documentElement.scrollTop)
    next()
  },
  activated:function() {
    this.$nextTick(() => {
      document.documentElement.scrollTop = localStorage.getItem("scrollHomeCategory")
      localStorage.setItem("scrollHomeCategory", 0)
    })
  },
  methods: {
    // 跳转
    onNavigate (item,index) {
      console.log(item)
      this.$router.push({
        path: '/homeCategory',
        query: {
          from : 'category',
          tab: this.tab,
          id: item.id,
          name : item.name,
          activeTag: item.pid,
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.home-category {
  overflow-y: scroll;
  background: #fff;
  /*padding-top: 16px;*/
  .scroll-wrapper {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }
  .scroll-content {
    display: inline-block;
    .item-img{
      display: block;
      width: 45px;
      height: 45px;
      border-radius: 50%;
      overflow: hidden;
      background: #f5f5f5;
      margin: 0 auto;
    }
    .scroll-item__wrapper {
      .scroll-item {
        font-size: 13px;
        display: inline-block;
        text-align: center;
        color: #666666;
        img {
          display: block;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          overflow: hidden;
          background: #f5f5f5;
          margin: 0 auto;
        }
        .text {
          width: 75px;
          margin-top: 12px;
        }
      }
    }
  }
  .dot-wrapper {
    width: 80px;
    height: 4px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    margin: 0 auto;
    overflow: hidden;
    .dot {
      box-sizing: border-box;
      width: 40px;
      height: 4px;
      transition: all 0.4s linear;
      background: #fe003b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/goods/modules/Category.vue